



























export default {
  name: "TbButton",
  props: ["buttonText"],
  methods: {
      testFunction: function() {
        console.log('test clicked')
    }
  }
};
